<template>
  <v-app>
    <v-container>
      <div class="content" v-if="printData">
        <div>
          <v-row class="" justify="center">
            <v-col cols="4" evaluate="2" class="data pa-2 text-h4 font-weight-bold text-center">
              {{ this.$store.getters.companyName }}
            </v-col>
          </v-row>
        </div>
        <div>
          <v-row justify="space-between" class="ammar" dense>
            <v-col cols="5" class="mt-9 text-right">
              <h5 class="mb-1">حركة البوالص حسب المعطيات</h5>
            </v-col>

            <v-col cols="3" class="mt-5 text-right">
              <v-row>
                <v-col cols="4"> تاريخ الطباعة </v-col>
                <v-col cols="5" class="">{{ print.date }}</v-col>
              </v-row>

              <v-row>
                <v-col cols="4"> التوقيت </v-col>
                <v-col cols="5" class="">{{ print.time }}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>

        <v-row class="mb-5">
          <v-col cols="12 m-0 p-0 mt-5">
            <v-data-table
              :headers="headers"
              :items="shipments"
              :server-items-length="total"
              :items-per-page="-1"
              class="elevation-1"
              group-by="paymentType"
              hide-default-footer>
              <template v-slot:[`group.header`]="{ items }">
                <th :colspan="options.paymentType == null ? 9 : 2" style="height: auto; border: red solid 2px !important">
                  {{ items[0].paymentType | PaymentTypes }}
                </th>
                <th
                  v-if="
                    items[0].paymentType == 1 && options.paymentType == null
                  "
                  colspan="1"
                  class="text-center red--text"
                  style="height: auto">
                  {{ reviewShipments(1).totalquantity }}
                </th>
                <th
                  v-if="
                    items[0].paymentType == 2 && options.paymentType == null
                  "
                  colspan="1"
                  class="text-center red--text"
                  style="height: auto">
                  {{ reviewShipments(2).totalquantity }}
                </th>
                <th
                  v-if="
                    items[0].paymentType == 1 && options.paymentType == null
                  "
                  colspan="1"
                  class="text-center red--text"
                  style="height: auto">
                  {{ reviewShipments(1).totalitemsprice }}
                </th>
                <th
                  v-if="
                    items[0].paymentType == 2 && options.paymentType == null
                  "
                  colspan="1"
                  class="text-center red--text"
                  style="height: auto">
                  {{ reviewShipments(2).totalitemsprice }}
                </th>
                <th
                  v-if="
                    items[0].paymentType == 1 && options.paymentType == null
                  "
                  colspan="1"
                  class="text-center red--text"
                  style="height: auto">
                  {{ reviewShipments(1).totaladdedValueTax }}
                </th>
                <th
                  v-if="
                    items[0].paymentType == 2 && options.paymentType == null
                  "
                  colspan="1"
                  class="text-center red--text"
                  style="height: auto">
                  {{ reviewShipments(2).totaladdedValueTax }}
                </th>
                <th
                  v-if="
                    items[0].paymentType == 1 && options.paymentType == null && (options.hasDuePrice == true || options.duePriceReceived == true)
                  "
                  colspan="1"
                  class="text-center red--text"
                  style="height: auto">
                  {{ reviewShipments(1).totalduePrice }}
                </th>
                <th
                  v-if="
                    items[0].paymentType == 2 && options.paymentType == null && (options.hasDuePrice == true || options.duePriceReceived == true)
                  "
                  colspan="1"
                  class="text-center red--text"
                  style="height: auto">
                  {{ reviewShipments(2).totalduePrice }}
                </th>
                <th
                  v-if="
                    items[0].paymentType == 1 && options.paymentType == null && options.hasOtherServicesPrice == true
                  "
                  colspan="1"
                  class="text-center red--text"
                  style="height: auto">
                  {{ reviewShipments(1).totalotherServicesPrice }}
                </th>
                <th
                  v-if="
                    items[0].paymentType == 2 && options.paymentType == null && options.hasOtherServicesPrice == true
                  "
                  colspan="1"
                  class="text-center red--text"
                  style="height: auto">
                  {{ reviewShipments(2).totalotherServicesPrice }}
                </th>
                <th
                  v-if="
                    items[0].paymentType == 1 && options.paymentType == null
                  "
                  colspan="1"
                  class="text-center red--text"
                  style="height: auto">
                  {{ reviewShipments(1).totalPrice }}
                </th>
                <th
                  v-if="
                    items[0].paymentType == 2 && options.paymentType == null
                  "
                  colspan="1"
                  class="text-center red--text"
                  style="height: auto">
                  {{ reviewShipments(2).totalPrice }}
                </th>
              </template>
              <template v-slot:[`item.date`]="{ item }">
                {{ item.date | ToDate }}
              </template>
              <template v-slot:[`item.trip.trackingNumber`]="{ item }">
                <div v-if="item.trip && item.trip.trackingNumber">
                  <div v-if="item.trip.line && item.trip.line.name">
                    {{ item.trip.line.name }}
                  </div>
                  <div class="red--text" v-if="item.paymentPaidType == 0">
                    غير محدد
                  </div>
                  <div v-else>
                    {{ item.paymentPaidType | PaymentPaidTypes }}
                  </div>
                </div>
              </template>
              <template v-slot:[`item.number`]="{ item }">
                {{ shipments.indexOf(item) + 1 }}
              </template>
              <template v-slot:[`item.items`]="{ item }">
                <span> {{ getItemNames(item) }} </span>
              </template>
              <template v-slot:[`item.quantity`]="{ item }">
                {{ getItemQuantity(item) }}
              </template>
              <template v-slot:[`item.itemprice`]="{ item }">
                {{ getItemPrice(item) }}
              </template>
              <template v-slot:[`item.addedValueTax`]="{ item }">
                {{ getItemTax(item) }}
              </template>
              <template v-slot:[`item.senderInfo`]="{ item }">
                <span v-if="item.senderInfo">
                  <span v-if="item.senderInfo">
                    {{ item.senderInfo.name }}</span>
                </span>
              </template>
              <template v-slot:[`item.receiverInfo`]="{ item }">
                <span v-if="item.receiverInfo">
                  <span v-if="item.receiverInfo.name">
                    {{ item.receiverInfo.name }}</span>
                  <br>
                  <span v-if="item.receiverInfo.phoneNumber">{{ item.receiverInfo.phoneNumber }}</span>
                </span>
              </template>
              <template slot="body.append" v-if="options.paymentType != null">
                <tr class="red--text">
                  <td class="text-center" />
                  <td class="text-center" />
                  <td class="text-center" />
                  <td class="text-center" />
                  <td class="text-center" />
                  <td class="text-center" />
                  <td class="text-center" />
                  <td class="text-center" />
                  <td class="text-center" />
                  <td class="text-center">
                    {{ shipmentsTotalquantity }}
                  </td>
                  <td class="text-center">
                    {{ shipmentsTotalitemsprice }}
                  </td>
                  <td class="text-center">
                    {{ shipmentstotaltax }}
                  </td>
                  <td class="text-center">
                    {{ shipmentsPriceTotal }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </div>
      <div v-if="!printData">Loading</div>
    </v-container>
  </v-app>
</template>

<script>
import ShipmentService from "../../LandShipping/services/ShipmentService";
import Enums from "../../../plugins/enums.js";

export default {
  mounted() {
    if (this.$route.query.options) {
      const data = JSON.parse(this.$route.query.options);
      const branch = JSON.parse(this.$route.query.branch);
      if (data) this.options = data;
      this.getDataFromAPI(branch);
    }
  },
  data() {
    return {
      shipments: [],
      printData: false,
      total: 10,
      print: {
        time: new Date().toLocaleTimeString(),
        date: this.formateDateWithMoment(Date.now(), "YYYY-MM-DD"),
      },
      options: {
        trackingNumber: null,
        sender: null,
        receiver: null,
        senderPhoneNumber: null,
        receiverPhoneNumber: null,
        serviceTypeId: null,
        employeeId: null,
        paymentType: null,
        distributorId: null,
        externalShipperId: null,
        salesmanId: null,
        date: null,
        state: -1,
        startDate: null,
        endDate: null,
        manualNoFrom: null,
        manualNoTo: null,
        manualNo: null,
        bookNumber: null,
        duePriceReceived: null,
        hasDuePrice: null,
        otherServicesPriceReceived: null,
        hasOtherServicesPrice: null,
        deliveryDate: null,
        cashPaid: null,
        recipientType: -1
      },
    };
  },
  computed: {
    headers() {
      const headers = [
        {
          text: "م",
          align: "start",
          sortable: true,
          value: "number",
        },
        {
          text: "التاريخ",
          value: "date",
          align: "right",
        },
        {
          text: "رقم البوليصة",
          value: "trackingNumber",
          align: "center",
        },
        {
          text: "الرحلة",
          value: "trip.trackingNumber",
          align: "start",
          width: "15%",
        },
        {
          text: "الرقم اليدوي",
          value: "manualNo",
          align: "right",
        },
        {
          text: "نوع الخدمة",
          value: "serviceType.name",
          align: "right",
          width: "10%",
        },
        {
          text: "المرسل",
          value: "senderInfo",
          align: "center",
          width: "12%",
        },
        {
          text: "المرسل اليه",
          value: "receiverInfo",
          align: "right",
          width: "12%",
        },
        {
          text: "الصنف",
          value: "items",
          align: "right",
          width: "8%",
        },
        {
          text: "عدد الطرود",
          value: "quantity",
          align: "right",
        },
        {
          text: "سعر الصنف ",
          value: "itemprice",
          align: "right",
        },
        {
          text: "ضريبه الصنف ",
          value: "addedValueTax",
          align: "right",
        },
        {
          text: "المسترد",
          value: "duePrice",
          align: "right",
        },
        {
          text: "قيمة الامر",
          value: "totalPrice",
          align: "right",
        },
      ];
      if (this.options.hasOtherServicesPrice || this.options.hasOtherServicesPrice == true || this.options.otherServicesPriceReceived || this.options.otherServicesPriceReceived == true) {
        headers.splice(12, 1);
        headers.push({
          text: "التغليف",
          value: "otherServicesPrice",
          align: "right",
        });
      }
      if ((!this.options.hasDuePrice || this.options.hasDuePrice == false) && (!this.options.duePriceReceived || this.options.duePriceReceived == false)) {
        headers.splice(12, 1);
        headers.push({
          text: "الملاحظات",
          value: "notice",
          align: "right",
          width: "20%"
        });
      }
      return headers;
    },
    shipmentsTotalquantity() {
      const total = this.shipments.reduce((accumulator, currentValue) => accumulator + this.getItemQuantity(currentValue), 0);
      return total;
    },
    shipmentsTotalitemsprice() {
      const total = this.shipments.reduce((accumulator, currentValue) => accumulator + this.getItemPrice(currentValue), 0);
      return this.round(parseFloat(total));
    },
    shipmentsTotalduePrice() {
      const total = this.shipments.reduce((accumulator, currentValue) => accumulator + (currentValue.duePrice || 0), 0);
      return this.round(parseFloat(total));
    },
    shipmentsPriceTotal() {
      const total = this.shipments.reduce((accumulator, currentValue) => accumulator + (currentValue.totalPrice || 0), 0);
      return total;
    },
    shipmentstotaltax() {
      const total = this.shipments.reduce((accumulator, currentValue) => accumulator + this.getItemTax(currentValue), 0);
      return this.round(parseFloat(total));
    },
  },
  methods: {
    getItemNames(item) {
      if (!item || !item.items || !item.items.length) return "";
      return item.items
        .map((i) => (i.merchandise && i.merchandise.name) || i.name || "")
        .filter(Boolean)
        .join(" - ");
    },
    getItemQuantity(item) {
      if (!item || !item.items || !item.items.length) return 0;
      return item.items.reduce((acc, i) => acc + (parseFloat(i.quantity) || 0), 0);
    },
    getItemPrice(item) {
      if (!item || !item.items || !item.items.length) return 0;
      const sum = item.items.reduce((acc, i) => acc + (parseFloat(i.price) || 0), 0);
      return this.round(sum, 2);
    },
    getItemTax(item) {
      if (!item || !item.items || !item.items.length) return 0;
      const sum = item.items.reduce((acc, i) => acc + (parseFloat(i.addedValueTax) || 0), 0);
      return this.round(sum, 2);
    },
    printopen() {
      setTimeout(() => {
        window.focus();
        const css = "@page { size: landscape; }";
        const head = document.head || document.getElementsByTagName("head")[0];
        const style = document.createElement("style");

        style.type = "text/css";
        style.media = "print";

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }

        head.appendChild(style);
        window.print();
      }, 100);
    },
    getDataFromAPI(isbranch) {
      this.options.itemsPerPage = -1;
      if (isbranch == true) {
        ShipmentService.clientDelivery(this.$clean(this.options)).then(
          (resp) => {
            this.shipments = resp.data.items;
            this.total = resp.data.total;
            console.log(this.shipments);
            this.printData = true;
            this.printopen();
          }
        );
      } else {
        ShipmentService.query(this.$clean(this.options)).then((resp) => {
          this.shipments = resp.data.items;
          console.log(this.shipments);
          this.printData = true;
          this.printopen();
        });
      }
    },
    reviewShipments(value) {
      const reviewShipments = this.shipments.filter((i) => i.paymentType == value);
      const totalquantity = reviewShipments.reduce(
        (
          accumulator,
          currentValue
        ) => accumulator + this.getItemQuantity(currentValue),
        0
      );
      let totalitemsprice = reviewShipments.reduce(
        (
          accumulator,
          currentValue
        ) => accumulator + this.getItemPrice(currentValue),
        0
      );
      let totaladdedValueTax = reviewShipments.reduce(
        (
          accumulator,
          currentValue
        ) => accumulator + this.getItemTax(currentValue),
        0
      );
      const totalPrice = reviewShipments.reduce(
        (
          accumulator,
          currentValue
        ) => accumulator + (currentValue.totalPrice || 0),
        0
      );
      let totalduePrice = reviewShipments.reduce(
        (
          accumulator,
          currentValue
        ) => accumulator + (currentValue.duePrice || 0),
        0
      );
      const totalotherServicesPrice = reviewShipments.reduce(
        (
          accumulator,
          currentValue
        ) => accumulator + (currentValue.otherServicesPrice || 0),
        0
      );
      totalitemsprice = this.round(parseFloat(totalitemsprice));
      totaladdedValueTax = this.round(parseFloat(totaladdedValueTax));
      totalduePrice = this.round(totalduePrice);
      return {
        totalquantity,
        totalitemsprice,
        totaladdedValueTax,
        totalduePrice,
        totalotherServicesPrice,
        totalPrice,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  -webkit-print-color-adjust: exact !important;
  /* Chrome, Safari */
  color-adjust: exact !important;
  /*Firefox*/
}

.content {
  font-weight: 600 !important;
}

@media print {}

::v-deep .v-data-table-header {
  background-color: #8080802b;
}

::v-deep .v-data-table tr {
  font-size: x-small !important;
  height: 14px !important;
  border: black solid 2px !important;
}

::v-deep .v-data-table td {
  font-size: x-small !important;
  height: 20px !important;
  border: black solid 2px !important;
}

::v-deep .v-data-table th {
  font-size: x-small !important;
  border: black solid 2px !important;
}

.ammar div {
  margin: 0 !important;
  padding: 1px !important;
  font-weight: bold;
}

.ammar div .edit {
  margin-top: 20px !important;
}

.data {
  border: 2px solid grey;
}

.both {
  position: absolute;
}

.dashed-border {
  border: 2px dotted grey;
  padding: 10px;
}

.first {
  bottom: -32px;
  left: 33%;
}

.second {
  bottom: 33;
  left: 8%;
}

.review div {
  border: 2px solid black;
  display: inline-block;
  font-weight: bold;
}
</style>
